<template>
  <div justify="center">
    <v-dialog 
    v-model="dialog"  max-width="1000px">      
      <v-card>                
        <v-card-title style="color: #00aeef; padding-bottom:5px">
          <h3>Visualización Datos</h3>
        </v-card-title>
        <v-card-text style="vertical-align: top; padding-top:-5px">
            <v-container>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.Sucursal"
                            label="Sucursal"
                        ></v-text-field>
                    </v-flex>
                    <v-flex
                    xs12
                    md6
                    >
                        <v-text-field
                            readonly
                            :value="data.identificacion"
                            label="Id. Cliente"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.NombreCliente"
                            label="Nombre cliente"
                        ></v-text-field>
                    </v-flex>
                    <v-flex
                    xs12
                    md6
                    >
                        <v-text-field
                            readonly
                            :value="data.IdBeneficiario"
                            label="Id. Beneficiario"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.NombreBeneficiario"
                            label="Nombre beneficiario"
                        ></v-text-field>
                    </v-flex>
                    <v-flex
                    xs12
                    md6
                    >
                        <v-text-field
                            readonly
                            :value="data.CodigoRamo"
                            label="Ramo"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.CodigoPoliza"
                            label="Póliza"
                        ></v-text-field>
                    </v-flex>
                    <v-flex
                    xs12
                    md6
                    >
                        <v-text-field
                            readonly
                            :value="data.CodigoOrden"
                            label="Orden"
                        ></v-text-field>
                        
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.CodigoCertificado"
                            label="Certificado"
                        ></v-text-field>
                    </v-flex>
                    <v-flex
                    xs12
                    md6
                    >
                        <v-text-field
                            readonly
                            :value="data.Producto"
                            label="Producto"
                        ></v-text-field>
                        
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.Endoso"
                            label="Endoso"
                        ></v-text-field>
                    </v-flex>
                         <v-flex
                    xs12
                    md6
                    >
                        <v-text-field
                            readonly
                            :value="data.LineaNegocio"
                            label="Linea de Negocio"
                        ></v-text-field>
                        
                    </v-flex>
                    
                </v-layout>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.FechaPago"
                            label="Fecha Facturación"
                        ></v-text-field>
                    </v-flex>
                  <v-flex
                    xs12
                    md6
                    >
                        <v-text-field
                            readonly
                            :value="data.FechaEmision"
                            label="Fecha Emisión"
                        ></v-text-field>
                        
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.FechaPagoComision"
                            label="Fecha Pago Comisión"
                        ></v-text-field>
                    </v-flex>
                  <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.FechaInicioVigencia"
                            label="Fecha inicio de vigencia"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.FechaFinVigencia"
                            label="Fecha fin de vigencia"
                        ></v-text-field>
                    </v-flex>
                    <v-flex
                    xs12
                    md6
                    >
                        <v-text-field
                            readonly
                            :value="data.NumeroLiquidacionAps"
                            label="Numero de Liquidación Aps"
                        ></v-text-field>
                        
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.PrimaItem"
                            label="Prima item"
                        ></v-text-field>
                    </v-flex>
                    <v-flex
                    xs12
                    md6
                    >
                        <v-text-field
                            readonly
                            :value="data.PrimaNeta"
                            label="Prima neta"
                        ></v-text-field>
                        
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.ValorComision"
                            label="Valor comisión"
                        ></v-text-field>
                    </v-flex>
                    <v-flex
                    xs12
                    md6
                    >
                        <v-text-field
                            readonly
                            :value="data.PorcentajeComision"
                            label="Porcentaje comisión"
                        ></v-text-field>
                        
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.Chasis"
                            label="Chasis"
                        ></v-text-field>
                    </v-flex>
                    <v-flex
                    xs12
                    md6
                    >
                        <v-text-field
                            readonly
                            :value="data.NumeroRecibo"
                            label="No Recibo"
                        ></v-text-field>
                        
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex
                    xs12
                    md6
                    class="mr-3"
                    >
                        <v-text-field
                            readonly
                            :value="data.FacturaReal"
                            label="No Factura"
                        ></v-text-field>
                    </v-flex>
                     <v-flex
                    xs12
                    md6
                    >
                        <v-text-field
                            readonly
                            :value="data.NumeroFacturaAps"
                            label="No Factura Aps"
                        ></v-text-field>
                        
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
        <v-divider style="margin:0px"></v-divider>     
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" small text @click="dialog = false">Cerrar</v-btn>                    
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment';
export default {    
    data () {
        return {        
            dialog: false,
            data: {},
        }
    },

    methods: {
        openDialog(data){
            this.data = data;
            this.dialog=true;
        },
    }
}
</script>
<style>
#tableDialog table.v-table thead tr th {
    color: #005CAE;
}
</style>